/**
 * Hono RPC client — typed end-to-end against api-worker.
 *
 * AppType import is type-only; the client is constructed against the
 * runtime URL (proxied to wrangler dev or hitting api.pozyskajpacjenta.pl
 * in prod). All requests carry credentials so the httpOnly session cookie
 * flows through cross-origin in prod (CF SaaS Custom Hostname maps both
 * admin app + api to the same eTLD+1 in production).
 */

import { hc } from 'hono/client';
import type { AppType } from '@h2m/api-worker';

import { env } from './env';

export const api = hc<AppType>(env.apiBaseUrl, {
  fetch: ((input, init) =>
    fetch(input as RequestInfo, {
      ...(init as RequestInit | undefined),
      credentials: 'include',
    })) as typeof fetch,
});
